import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import ExecucaoPlano from "components/qualidade/ExecucaoPlano";
import OrdemProducao from "model/producao/OrdemProducao";
import ExecucaoPlanoQualidade from "model/qualidade/ExecucaoPlanoQualidade";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import QualidadeProdutoAcabadoService from "service/qualidade/QualidadeProdutoAcabadoService";

const produtoAcabadoService = new QualidadeProdutoAcabadoService();

export default function QualidadeProdutoAcabadoCadastro() {

    const [queryParameters] = useSearchParams();

    const [ordemProducao, setOrdemProducao] = useState<OrdemProducao>(new OrdemProducao());
    const [titulo, setTitulo] = useState<string>('Inspeção de Produto Acabado');

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();


    function validar() {
        return true;
    }

    return (

        <BaseCadastro model={ordemProducao} service={produtoAcabadoService} setModel={(value: OrdemProducao) => setOrdemProducao(value)} validar={() => validar()} 
            urlService="/qualidade/produtoAcabado" pathCadastro="/qualidade/produtoAcabado" tituloPagina={'Produto Acabado'}
        >

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 12 }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label style={{ fontWeight: 700 }}>Produto</label>
                <div style={{ display: "flex" }}>
                    <InputText style={{ width: "20%", marginRight: 10 }} value={ordemProducao.produto?.codigo || ''} disabled />
                    <InputText style={{ width: "30%" }} value={ordemProducao.produto?.nome || ''} disabled />
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label style={{ fontWeight: 700 }}>Lote</label>
                <InputText style={{ width: "20%" }} value={ordemProducao.lote || ''} disabled />
            </div>

            <div style={{ display: "flex", flexDirection: "column", marginBottom: 12 }}>
                <label style={{ fontWeight: 700 }}>Quantidade Produzida</label>
                <InputText style={{ width: "20%" }} value={ordemProducao.qtProduzida+"" || ''} disabled />
            </div>

            <ExecucaoPlano value={ordemProducao.execucaoPlanoQualidade || new ExecucaoPlanoQualidade()} onChange={(value) => { setOrdemProducao({ ...ordemProducao, execucaoPlanoQualidade: value }) }} editable={true} />

        </BaseCadastro>
    )
}
